import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "bullet", "wrapper"]
    static values = {
        activeClass: String,
        autoscroll: Boolean,
        autoscrollInterval: Number, default: 3
    }
    connect() {
      this.currentIndex = 0
      this.items = this.itemTargets
      if (this.autoscrollValue) {
        this.startAutoscroll()
      }

      this.intersectionObserver = new IntersectionObserver(this.handleIntersectionObserver.bind(this), {
        root: this.wrapperTarget,
        threshold: 0.75
      })

      this.items.forEach(item => this.intersectionObserver.observe(item))
    }

    disconnect() {
      clearInterval(this.interval)
      this.intersectionObserver.disconnect()
    }

    startAutoscroll() {
      const interval = (this.autoscrollIntervalValue) * 1000
      this.interval = setInterval(() => this.next(), interval)
    }

    next(event) {
      event?.preventDefault()
      this.currentIndex = (this.currentIndex + 1) % this.items.length
      this.scrollToCurrentItem()
      this.updateBullets()
    }

    previous(event) {
      event?.preventDefault()
      this.currentIndex =
        (this.currentIndex - 1 + this.items.length) % this.items.length
      this.scrollToCurrentItem()
      this.updateBullets()
    }

    goTo(event) {
        event?.preventDefault()

        const index = parseInt(event.params.index, 10)
        if (isNaN(index)) return

        this.currentIndex = index
        this.scrollToCurrentItem()
        this.updateBullets()
      }

    scrollToCurrentItem() {
      const currentItem = this.items[this.currentIndex]
      if (!currentItem) return

      currentItem.scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest" // remove vertical scrolling
      })
    }

    handleIntersectionObserver(entries) {
        entries.forEach((entry) => {
          const elem = entry.target
          const intersectedItemIndex = this.items.findIndex(item => item === elem)

          if (entry.isIntersecting) {
            if (entry.intersectionRatio >= 0.75) {
              this.currentIndex = intersectedItemIndex
              this.bulletTargets[intersectedItemIndex].classList.add(this.activeClassValue)
            }
          } else {
            this.bulletTargets[intersectedItemIndex].classList.remove(this.activeClassValue)
          }
        })
    }
  }
